export default __webpack_public_path__ + "static/media/mocha.13788684.svg";